import { isEmptyObject } from './is'

export default function qs(obj = {}) {
  if (isEmptyObject(obj)) {
    return null
  }

  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(obj)) {
    params.append(k, v)
  }

  // return decodeURIComponent(params) //.replace(/%2F/gmi, '/')
  return params
}